



















/**
 * External dependencies.
 */
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Badges extends Vue {
  @Prop(Array) badges!: Array<any>
}
